import { useTranslation } from 'react-i18next';

import { Modal } from '@thinknet-gmbh/platform-common-ui';
import { DocumentTypesEnum } from '@thinknet-gmbh/platform-common';

import { File } from 'src/pages/vacancies/vacancies.interfaces';
import { useGetApplicantDocumentPreview } from 'src/hooks/applicants/get-applicant-document-preview.hook';
import { DocumentViewer } from 'src/components/document-viewer';

const PreviewDocumentModal = ({
  isOpened,
  onClose,
  document,
}: {
  isOpened: boolean;
  onClose: () => void;
  document: File | null;
}) => {
  const { t } = useTranslation('vacancies');
  const { document: doc, loading } = useGetApplicantDocumentPreview(
    String(document?.location).includes('pdf') ? DocumentTypesEnum.PDF : DocumentTypesEnum.DOC,
    document?._id
  );

  return (
    <Modal isOpened={isOpened} onClose={onClose} title={t('labels.documentView')} modalWidth={1000}>
      <DocumentViewer loading={loading} base64={doc.base64} />
    </Modal>
  );
};

export default PreviewDocumentModal;
